import ProductPage from './ProductPage';

export default ProductPage;



// WEBPACK FOOTER //
// ./src/components/ProductPage/index.js